<template>
  <div class="mx-4 sub-content">
    <label class="mt-2">
      Do you have an outstanding application with the Home Office before your
      previous leave expired or have an outstanding appeal against a Home Office
      decision?
    </label>
    <RadioButton
      @select="hasOutstandingAppealChange"
      :selected-value="answers.hasOutstandingAppeal"
      :options="booleanOptions"
      showGroupInRow
    />
    <label class="mt-2">
      Does the Home Office say that you are allowed to work in the UK?
    </label>
    <RadioButton
      @select="isAllowedToWorkChange"
      :selected-value="answers.isAllowedToWork"
      :options="booleanOptions"
      showGroupInRow
    />
  </div>
</template>

<script>
import { BOOLEAN_OPTIONS } from "@/constants/common";
import RadioButton from "@/components/common/RadioButton";

export default {
  props: {
    extendedAnswers: Object
  },
  components: { RadioButton },
  data() {
    return {
      booleanOptions: BOOLEAN_OPTIONS,
      answers: this.extendedAnswers
    };
  },
  methods: {
    hasOutstandingAppealChange(selectedValue) {
      this.answers.hasOutstandingAppealChange = selectedValue;
      this.$emit("change", this.answers);
    },
    isAllowedToWorkChange(selectedValue) {
      this.answers.isAllowedToWork = selectedValue;
      this.$emit("change", this.answers);
    }
  }
};
</script>

<style lang="scss" scoped></style>
